export default String.raw`.textElement{padding:32px 32px}`